import React, { useEffect, useState } from "react";
import axios from "axios";
import { BrowserRouter, Route, Switch, Redirect, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import PrivateRoute from "./components/routing/PrivateRoute";
import setAuthToken from "./utils/setAuthToken";
import "bootstrap/dist/css/bootstrap.min.css";
import Notification from "./components/layout/Notification";
import "./App.css";
import { getBaseUrl } from "./config";
import {
    FEDERAL_SIGNUP_LINK,
    FMCSA_VERIFICATION_LINK, FORGOT_PASSWORD,
    LOGIN_LINK, ONBOARDING_USER,
    SIGNUP_SUPPORT
} from "./components/constants";
import LoadModuleAsync from "./components/Atoms/LoadModuleAsync";
import { ENHANCED_DASHBOARD } from "./components/client/routes";
import { Box } from "@mui/material";
import { buildAppVariables } from "./actions/app.action";
import { getLoads } from "./actions/load";
import FreightDokOpenBoard from './views/openBoard/FreightDokOpenBoard';
import FleetIntelligence from './views/fleetIntelligence/FleetIntelligence';

const SignUp = LoadModuleAsync(() => import("./components/auth/signUpWithFMCSA/SignUp"))
const Support = LoadModuleAsync(() => import("./components/auth/signUpWithFMCSA/Support"))
const LandingPage = LoadModuleAsync(() => import("./views/landingPage/LandingPage"));
const UserOnboard = LoadModuleAsync(() => import("./components/auth/signUpWithFMCSA/UserOnboard"));
const EnhancedDashboard = LoadModuleAsync(() => import("./layout/EnhancedDashboard"), true);
const Login = LoadModuleAsync(() => import('./components/auth/Login'), true);
const FMCSASignup = LoadModuleAsync(() => import("./components/auth/signUpWithFMCSA/FMCSASignup"), true)
const ForgotPassword = LoadModuleAsync(() => import("./views/auth/ForgotPassword"), true)

if (localStorage.token) {
    setAuthToken(localStorage.token);
}

axios.defaults.baseURL = getBaseUrl() || (typeof window !== 'undefined' ? window.location.origin : '');

const PreAuthRoutes = () => {
    return <>
        {/*<Route path="/register" component={Register}/>*/}
        <Route path={LOGIN_LINK} component={Login} />
        <Route path={FEDERAL_SIGNUP_LINK} component={SignUp} />
        <Route path={FMCSA_VERIFICATION_LINK} component={FMCSASignup} />
        <Route path={SIGNUP_SUPPORT} component={Support} />
        <Route path={ONBOARDING_USER} component={UserOnboard} />
        <Route path={FORGOT_PASSWORD} component={ForgotPassword} />
    </>
}

const MagicLinkHandler = () => {
    const location = useLocation();
    const [message, setMessage] = useState('Validating magic link...');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const redirect = params.get('redirect') || '';

        if (!token) {
            setMessage('Missing magic link token.');
            return;
        }

        const run = async () => {
            try {
                const response = await axios.get(`/api/auth/magic-link?token=${encodeURIComponent(token)}`);
                const jwtToken = response.data?.token;
                const loadId = response.data?.loadId;
                if (jwtToken) {
                    localStorage.setItem('token', jwtToken);
                    setAuthToken(jwtToken);
                }
                const target = redirect || (loadId ? `/freightdok-open-board?load=${loadId}` : '/freightdok-open-board');
                window.location.replace(target);
            } catch (err) {
                const fallback = redirect || '/freightdok-open-board';
                setMessage('Magic link failed. Redirecting to login...');
                window.location.replace(`${LOGIN_LINK}?redirect=${encodeURIComponent(fallback)}`);
            }
        };

        run();
    }, [location.search]);

    return (
        <div style={{ padding: 24, textAlign: 'center', color: '#6b7280' }}>
            {message}
        </div>
    );
};

const App = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(buildAppVariables())
    }, [dispatch])

    // Global listener to refetch loads after updates anywhere in the app
    useEffect(() => {
        const handleLoadUpdated = () => {
            try { dispatch(getLoads(0, 100, '', '')); } catch (_) {}
        };
        window.addEventListener('loadUpdated', handleLoadUpdated);
        return () => window.removeEventListener('loadUpdated', handleLoadUpdated);
    }, [dispatch]);

    return (
        <Box sx={{ height: '100%' }} className='freightdok-root'>
            <Notification />
            <BrowserRouter>
                <Switch>
                    <Route exact path={'/'}><Redirect to={ENHANCED_DASHBOARD} /></Route>
                    <Route path={'/home'} component={LandingPage} />
                    <Route path={'/magic-link'} component={MagicLinkHandler} />
                    <Route exact path="/business-intelligence"><Redirect to="/fleet-intelligence" /></Route>
                    {/*<Route path="/entity" component={EntityType} />*/}
                    {/*<Route path="/ownerOperatorRegister" component={OwnerOp} />*/}
                    {/*<Route path='/setPassword' component={SetPassword} />*/}
                    <PrivateRoute path={ENHANCED_DASHBOARD} component={EnhancedDashboard} />
                    {/*<PrivateRoute path="/dashboard" component={Dashboard}/>*/}
                    {/*<PrivateRoute path="/profile" component={Profile}/>*/}
                    {/*<Route path="/fleetRegister" component={Fleet} />*/}
                    {/*<PrivateRoute path='*'><Redirect to={ENHANCED_DASHBOARD} /></PrivateRoute>*/}
                    {/*<PrivateRoute path="/create-profile" component={ProfileForm}/>*/}
                    {/*<PrivateRoute path="/edit-profile" component={EditProfile}/>*/}
                    {/*<PrivateRoute path="/loads" component={Loads}/>*/}
                    <PrivateRoute path="/fleet-intelligence" component={FleetIntelligence} />
                    <PrivateRoute path="/freightdok-open-board" component={FreightDokOpenBoard} />
                    <PreAuthRoutes />
                </Switch>
            </BrowserRouter>
        </Box>
    );
};

export default App;
